export const INPUT_BASE =
	'w-full rounded-md border border-subtle bg-white px-xs py-3xs text-[13px] text-default placeholder:text-subtle focus:border-purple-500 focus:outline-none';

export const TEXTAREA_BASE = `${INPUT_BASE} min-h-[120px] resize-y`;

export const BUTTON_PRIMARY =
	'inline-flex items-center gap-3xs rounded-md bg-purple-500 px-md py-3xs text-[12px] font-medium text-white transition-colors hover:bg-purple-700 disabled:cursor-not-allowed disabled:opacity-50';

export const BUTTON_GHOST =
	'inline-flex items-center gap-3xs rounded-md border border-subtle bg-white px-md py-3xs text-[12px] text-default transition-colors hover:bg-grey-25';

export const BUTTON_DANGER =
	'inline-flex items-center gap-3xs rounded-md border border-red-200 bg-white px-md py-3xs text-[12px] text-error transition-colors hover:bg-red-50';
